import { Feedback } from 'v2/core/entities/feedback';

export default function checkDisabledIndent(feedback: Feedback): boolean {
  return feedback?.sourceV2?.name === 'DISCOURSE';
}
